// Angular
import { ErrorHandler, Injectable, Injector } from '@angular/core';

// Common
import {  SharedService } from 'app/_services';

// 3rd Party

import * as _ from 'underscore';
import { CommonService } from './reusable/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({    providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
    destroySubject$: Subject<void> = new Subject();
    constructor(
        private sharedService: SharedService,
        private commonService: CommonService,
    ) { }

    public handleError(error: any): void {

        const ErrorUrl = "error"
        const body :{level:string,system:string,message:string,exception: string}={
            level:"Error",
            system: "Alpha.Portal",
            message: error.message,
            exception:JSON.stringify({exception: error.stack ,location : window.location.href})
        }
        this.commonService.create(ErrorUrl, body)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe();

        this.sharedService.emitChange({ action: 'preloader', value: false });
        throw error;

    }
}